export const PermissionsAvailable = {
  ACCESS_TO_ANALYTICS: 'access_actionable_payment_insights',
  BUILD_YOUR_CHECKOUT: 'build_your_checkout',
  CREATE_YOUR_PROCESSING_ROUTES: 'create_your_processing_routes',
  EXPORT_REPORTS: 'export_reports',
  EXPORT_SETTLEMENTS_REPORTS: 'export_settlement_reports',
  MANAGE_ACCOUNTS: 'manage_accounts',
  MANAGE_A_TEAM: 'manage_a_team',
  MANAGE_ROLES: 'manage_roles',
  MANAGE_CONNECTIONS: 'manage_connections',
  MANAGE_SETTINGS: 'manage_settings',
  MANAGE_WEBHOOKS: 'manage_webhooks',
  MANAGE_PAYMENT_LINKS: 'manage_payment_links',
  OPERATE_PAYMENTS: 'operate_payments',
  RECONCILIATION_DETAILS: 'reconciliation_details',
  VIEW_ACCOUNT_KEYS: 'view_account_keys',
  VIEW_CONNECTIONS: 'view_connections',
  VIEW_PAYMENT_TRANSACTIONS: 'view_payment_transactions',
  VIEW_SETTLEMENT_REPORTS: 'view_settlement_reports',
  VIEW_YOUR_CHECKOUT: 'view_your_checkout',
  VIEW_YOUR_PROCESSING_ROUTES: 'view_your_processing_routes',
  VIEW_BETA_FEATURE: 'view_beta_feature',
  VIEW_LOGS: 'view_logs',
  VIEW_PAYMENT_LINKS: 'view_payment_links',
}

export const PermissionsPath = {
  '/connections': PermissionsAvailable.VIEW_CONNECTIONS,
  '/routing': PermissionsAvailable.VIEW_YOUR_PROCESSING_ROUTES,
  '/reconciliations': PermissionsAvailable.VIEW_SETTLEMENT_REPORTS,
  '/checkout-builder': PermissionsAvailable.VIEW_YOUR_CHECKOUT,
  '/payments': PermissionsAvailable.VIEW_PAYMENT_TRANSACTIONS,
  '/routing/workflow': PermissionsAvailable.VIEW_YOUR_PROCESSING_ROUTES,
  '/users/roles/management': PermissionsAvailable.MANAGE_ROLES,
  '/accounts': PermissionsAvailable.MANAGE_ACCOUNTS,
  '/insights': PermissionsAvailable.ACCESS_TO_ANALYTICS,
  '/users/settings/team': 'all',
  '/developers': 'all',
  '/auth': 'all',
  '/users': 'all',
  '/users/settings': 'all',
  '/users/settings/security': 'all',
  '/users/help': 'all',
  '/audit': 'all',
  '/payment-links': 'all',
}
